<template>
  <v-app>
    <v-main>
      <div class="all_wrap" id="app">
        <custom-header title="학습현황">
        </custom-header>
        <div class="all_layout">
          <custom-tab :active="0"></custom-tab>
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import CustomHeader from '@/components/layout/CustomHeader.vue';
import CustomTab from "@/components/layout/CustomTab.vue";

export default {
  name: 'App',
  components: {
    CustomHeader,
    CustomTab,
  },
}
</script>

<style>
  .v-application,
  .v-application .title,
  .v-application .text-h5,
  .v-application .text-h6 {
    font-family: 'Noto Sans KR'!important;
  }
  .v-application p {
    margin-bottom: 5px;
    font-size: 0.95rem;
  }
</style>
